import { routes } from '@shared/constants/routes'
import { useIsPage } from '@/features/shared/hooks/useIsPage'
import { useParams } from 'next/navigation'

export const useOnUngatedCategories = () => {
  let ungatedURL: string = routes.UNGATED_CATEGORY.url
  const { UNGATED_CATEGORY } = useIsPage()
  const params = useParams<{ slug?: string | string[] }>()

  if (UNGATED_CATEGORY && params?.slug) {
    const slugArr = params.slug
    Array.isArray(slugArr)
      ? slugArr.forEach((str: string) => {
          ungatedURL = `${ungatedURL}/${str}`
        })
      : (ungatedURL = `${ungatedURL}/${slugArr}`)
    return ungatedURL
  }
}
